import React from "react";

import {
	SidebarContainer,
	Icon,
	NavLogoImg,
	CloseIcon,
	SidebarWrapper,
	SidebarMenu,
	SidebarLink,
} from "./Sidebar.styles";

const Sidebar = ({ isOpen, toggle }) => {
	return (
		<SidebarContainer isOpen={isOpen} onClick={toggle}>
			<Icon>
				<NavLogoImg
					src={process.env.PUBLIC_URL + "img/Logo.png"}
					alt="logo"
				/>
				<CloseIcon onClick={toggle} />
			</Icon>
			<SidebarWrapper>
				<SidebarMenu>
					<SidebarLink to="/#brand" onClick={toggle}>
						<h2>Brand</h2>
					</SidebarLink>
					<SidebarLink to="/#discover" onClick={toggle}>
						<h2>Discover</h2>
					</SidebarLink>
					<SidebarLink to="/#maps" onClick={toggle}>
						<h2>Maps</h2>
					</SidebarLink>
				</SidebarMenu>
			</SidebarWrapper>
		</SidebarContainer>
	);
};

export default Sidebar;
